<script>
import { format } from 'date-fns'
import EventBus from '../event-bus'

import store from '@/store'
import { mapGetters } from 'vuex'

import Praise from '@/components/Praise'
import ThankYou from '@/components/ThankYou'
import Feedback from '@/components/Feedback'

export default {
  props: {
    note: Object,
    visible: Boolean,
    recipients: Array,
    from: Object,
    user: String
  },
  components: {
      Praise,
      ThankYou,
      Feedback
  },
  data () {
      return {
          format,
          loading: false,
          step: 0,
          form: {},
          recipient: null
      }
  },
  mounted () {
      EventBus.$on("updateNote", this.updateNote)
      EventBus.$on("saveNote", this.onSave)
      EventBus.$on("shareNote", this.onShare)
  },
  methods: {
    updateNote (data) {
        for (let prop in data) {
            this.form[prop] = data[prop]
        }
    },
    fullName (from, r) {
        const f = r.FirstName.toLowerCase()
        const l = r.LastName.toLowerCase()

        if (from.EmployeeID === r.EmployeeID) {
            return `${f.charAt(0).toUpperCase()}${f.slice(1)}  ${l.charAt(0).toUpperCase()}${l.slice(1)} (myself)`
        }
        return `${f.charAt(0).toUpperCase()}${f.slice(1)}  ${l.charAt(0).toUpperCase()}${l.slice(1)}`
    },
    onSave() {

        this.loading = true

        if (!this.form.FeedBackID) {

            this.form.CreateDate = format(new Date(), 'X')
            this.form.CreatedForUserID = isNaN(parseInt(this.form.CreatedForUserID)) ? store.state.employeeId : this.form.CreatedForUserID


            store.dispatch('teacher/createNote', this.form)
            .then(( data ) => {

                this.loading = false

                this.form = {}
                
                const el = this.$createElement
                this.$notify({message: el('i', {}, 'note was created successfully')})

                EventBus.$emit('disableVisibility')

                this.$ga.event({
                    eventCategory: 'Create new note',
                    eventAction: store.getters['getDBN']
                        ? store.getters['getDBN']
                        : store.getters['admin/getSelectedSchool']['dbn'],
                    eventLabel: store.getters['getUserRole'],
                })
            })
            .catch((error) => {
                console.log(error)
            })
            
        } 
    },
    onShare(value) {

        this.loading = true

        if (!this.form.FeedBackID) {
            this.form.CreateDate = format(new Date(), 'X')
            this.form.CreatedForUserID = isNaN(parseInt(this.form.CreatedForUserID)) ? store.state.employeeId : this.form.CreatedForUserID
            this.form.IsPublished = value

            store.dispatch('teacher/createNote', this.form)
            .then(( data ) => {

                this.loading = false
                
                const el = this.$createElement
                this.$notify({message: el('i', {}, 'note was created successfully')})

                this.form = {}

                EventBus.$emit('disableVisibility')

                this.$ga.event({
                    eventCategory: 'Share a note',
                    eventAction: store.getters['getDBN']
                        ? store.getters['getDBN']
                        : store.getters['admin/getSelectedSchool']['dbn'],
                    eventLabel: store.getters['getUserRole'],
                })                
            })
            .catch((error) => {
                console.log(error)
            })

        } else {
            this.form.IsPublished = value
            
            this.form.UpdateDate = format(new Date(), 'X')

            store.dispatch('teacher/updateNote', this.form)
            .then(( data ) => {

                this.loading = false

                const el = this.$createElement
                this.$notify({message: el('i', {}, 'note was updated successfully')})

                this.form = {}

                EventBus.$emit('disableVisibility')

                this.$ga.event({
                    eventCategory: value === 1
                        ? 'Share a note'
                        : 'Un-share a note',
                    eventAction: store.getters['getDBN']
                        ? store.getters['getDBN']
                        : store.getters['admin/getSelectedSchool']['dbn'],
                    eventLabel: store.getters['getUserRole'],
                })
            })
            .catch((error) => {
                console.log(error)
            })
        }
        
    },
    resetNote () {
        const { employeeId } = store.state
        
        this.form = {}
        this.form.CreatedByUserID = employeeId
    },
    closeNote() {
        this.resetNote()
        EventBus.$emit('disableVisibility')
    }
  },
  computed: {
      selectedComponent() {
          const type = this.form.FeedBackType
          return type ? type.split(' ').map(i => `${i.charAt(0).toUpperCase()}${i.slice(1)}`).join('') : null
      }
  },
  watch: {
      visible (n, o) {

        let el = document.querySelector('.note')
        
        if (n) {

            el.style.display = 'block'

            el.childNodes[1].scrollIntoView({block: 'end', inline: 'end'})
            
        } else {
            el.style.display = 'none'
        }

        if (n && this.note) {
            this.form = this.note
            this.step = 1
        } else if (n && !this.note) {
            this.resetNote()
        }

      },
      'form.CreatedForUserID' (n) {
            const recipient = this.recipients.find(r => r.EmployeeID === n)
            this.recipient = recipient
      },
      'note': {
          handler: function(n) {
                const { employeeId } = store.state

                const obj = {CreatedByUserID: employeeId}
            
                this.form = n !== null ? n : obj
          },
          deep: true
      }
  }
}
</script>

<template>
    <div v-loading="loading" class="note">
        <div data-header-type="top">
            <button class="exit-btn" @click="closeNote">x</button>
        </div>
        <div v-if="!note && (form && !form.CreatedForUserID)" class="note-type">
            <div class="note-select">
                <p>What type of note are you writing today?</p>
                <div>
                    <el-radio-group class="note-select-radio" v-model="form.FeedBackType">
                        <div>
                            <el-radio-button label="praise"></el-radio-button>
                        </div>
                        <div>
                            <el-radio-button label="thank you"></el-radio-button>
                        </div>
                        <div>
                            <el-radio-button label="feedback"></el-radio-button>
                        </div>
                    </el-radio-group>
                    <el-select class="note-select-select" v-model="form.FeedBackType">
                        <el-option label="praise" value="praise"></el-option>
                        <el-option label="thank you" value="thank you"></el-option>
                        <el-option label="feedback" value="feedback"></el-option>
                    </el-select>
                </div>
                
            </div>
            <div class="note-recipient">
                <p>Who is the note for?</p>
                <el-select
                    :disabled="form.FeedBackType === undefined"
                    v-model="form.CreatedForUserID"
                    placeholder="Select a Recipient">
                    <el-option 
                    v-for='recipient in recipients' 
                    :key='recipient.EmployeeID' 
                    :value='recipient.EmployeeID' 
                    :label='fullName(from, recipient)'></el-option>
                </el-select>
            </div>
        </div>
        <div v-else>
            <component :user="user" :from="recipients.find(r => r.EmployeeID === form.CreatedByUserID)" :to="recipient" :view-only="form && form.FeedBackID !== undefined" :form="form" :is="selectedComponent"></component>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .note {
        display: none;
        padding: 10px;
        @media screen and (max-width: 1070px) {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: auto;
            background-color: #e7dbee;
        }
        background-color: rgba(207, 255, 229, 0.72);
        > div {
            padding: 10px;
        }
        [data-header-type="top"] {
            display: flex;
            button {
                flex: 5%;
            }
            h1 {
                flex: 95%;
                font-size: 18px;
                text-align: center;
                // font-family: 'amatic';
            }
        }
        &.notes-desktop {
            padding: 10px;
        }
        .note-type {
            > div {
                p {
                    text-align: center;
                    font-size: 18px;
                }
            }
            .note-select p {
                margin-bottom: 1em;
                @media screen and (min-width: 1070px) {
                    text-align: left;
                    line-height: 28px;
                }
            }
        }
        .note-select {
            display: flex;
            flex-direction: column;
            > div {
                @media screen and (min-width: 1070px) {
                    margin-bottom: 10px;
                }
            }
            @media screen and (min-width: 1070px) {
                padding: 0px 10px;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
            .note-select-radio {
                @media screen and (min-width: 1070px) {
                    display: none;
                }
            }
            .note-select-select {
                display: none;
                @media screen and (min-width: 1070px) {
                    display: block;
                }
            }
            p {
               margin: 0; 
            }
        }
        .exit-btn {
            padding: 0;
            width: 44px;
            height: 44px;
            font-size: 20px;
            text-align:left;
            cursor: pointer;
        }
        .save-btn {
            width: 131px;
            height: 25px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0, 0.5);
            background-color: #ae94bd;
        }
        button {
            background-color: transparent;
            border: none;
        }
        .note-type button.el-button {
            background-color: #ae94bd;
            color: #ffffff;
        }
    }
    .form {
        padding-top: 22px;
        .section {
            position: relative;
            margin: 0 10px 10px 10px;
            background-color: #ffffff;
            .display-date {
                font-family: 'museo_sans';
                position: absolute;
                right: 0;
            } 
        }
    }
    .note-recipient {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
        @media screen and (min-width: 1070px) {
            padding: 0px 10px;
            width: inherit;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        .note-select-radio {
            @media screen and (min-width: 1070px) {
                display: none;
            }
        }
    }
    .actions {
        margin: 0 10px 10px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .visible {
        display: block;
    }

</style>